import '../../scss/streetstyle-home.scss';

const $ = require('jquery');
require('jquery');
require('../common/viewer');
import {initSeeMore} from '../common/seeMoreResultInfiniteScroll';
import imgLazyload from '../common/imgLazyload';
const initFilters = require('./filters');

document.addEventListener('DOMContentLoaded', () => {
    initFilters();
    initSeeMore(document.querySelector('#results'), false);

    document.addEventListener('nextResultsFetched', () => {
        imgLazyload();
    });
});
